import Dictionary from './Dictionary';
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className='container'>
        <Dictionary defaultKeyword="Book"/>
        < footer className="d-flex justify-content-center mt-3">
          This project was coded by {""} <a href="mailto:mehrnazsadeghian8968@gmail.com" target="_blank" rel="noopener noreferrer">Mehrnaz Sadeghian</a>{""} and is {""}<a href="https://github.com/mymehrnaz/farhang-1" target="_blank" rel="noopener noreferrer">open-sourced on GitHub</a>{""}and{""}<a href="https://soft-rugelach-410c37.netlify.app/" target="_blank" rel="noopener noreferrer">hosted on netlify</a>
        </footer>
      </div>
    </div>
  );
}

export default App;
